import React from "react";

import { StyledMain } from "../../styled/StyledMain";
import { MainContainer } from "../../styled/StyledMainContainer";

import { StyledContainer } from "./styled/Container";
import GuestsTrackerSignin from "./components/GuestsTrackerSignin";

const GuestTrackerLogin = () => {
  return (
    <StyledMain grayBg>
      <MainContainer>
        <StyledContainer>
          <h2>Guest Tracker Login</h2>
          <GuestsTrackerSignin />
        </StyledContainer>
      </MainContainer>
    </StyledMain>
  );
};

export default GuestTrackerLogin;
